import { render, staticRenderFns } from "./digitize.vue?vue&type=template&id=10132e08&scoped=true"
import script from "./digitize.vue?vue&type=script&lang=js"
export * from "./digitize.vue?vue&type=script&lang=js"
import style0 from "./digitize.vue?vue&type=style&index=0&id=10132e08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10132e08",
  null
  
)

export default component.exports